var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('treeselect',{attrs:{"placeholder":"Select workflow...","disable-branch-nodes":true,"value":_vm.value,"options":_vm.workflows},on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"option-label",fn:function(ref){
var node = ref.node;
var shouldShowCount = ref.shouldShowCount;
var count = ref.count;
var labelClassName = ref.labelClassName;
var countClassName = ref.countClassName;
return _c('div',{staticClass:"label"},[(node.raw.timestamp)?_c('span',{staticClass:"description"},[_vm._v(_vm._s(_vm.formatDate(node.raw.timestamp))+" "+_vm._s(node.raw.description))]):_c('span',[_vm._v(_vm._s(node.id))])])}},{key:"value-label",fn:function(ref){
var node = ref.node;
return _c('div',{staticClass:"label"},[_c('span',[_vm._v(_vm._s(node.raw.name)+" | "+_vm._s(_vm.formatDate(node.raw.timestamp))+" | "+_vm._s(node.raw.description))])])}}])})}
var staticRenderFns = []

export { render, staticRenderFns }